import React, { useState, useEffect } from "react";
import { Button, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useAuth } from "../util/auth";

const StyledButton = styled(Button)(({ theme }) => ({
  color: '#1a1a1a',
  backgroundColor: 'white',
  border: '1px solid #e5e7eb',
  textTransform: 'none',
  fontSize: '16px',
  padding: '12px',
  marginBottom: '12px',
  '&:hover': {
    backgroundColor: '#f8f9fa',
    borderColor: '#d1d5db',
  },
}));

const IconWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginRight: '8px',
  '& img': {
    width: '20px',
    height: '20px',
  },
});

const LastUsedIndicator = styled('div')(({ theme }) => ({
  position: 'absolute',
  right: '12px',
  fontSize: '12px',
  color: theme.palette.text.secondary,
}));

function AuthSocial(props) {
  const auth = useAuth();
  const [pending, setPending] = useState(null);
  const [lastUsed, setLastUsed] = useState(null);

  const providerDisplayNames = {
    google: "Google",
    facebook: "Facebook",
    twitter: "Twitter",
    github: "GitHub",
  };

  const onSigninWithProvider = async (provider) => {
    setPending(provider);
    try {
      if (provider === 'google') {
        const user = await auth.signInWithGoogle();
        localStorage.setItem("lastUsedAuthProvider", provider);
        props.onAuth(user);
      } else {
        throw new Error(`Provider ${provider} is not supported`);
      }
    } catch (error) {
      setPending(null);
      props.onError(error.message);
    }
  };

  useEffect(() => {
    if (props.showLastUsed) {
      const lastUsed = window.localStorage.getItem("lastUsedAuthProvider");
      if (lastUsed) {
        setLastUsed(lastUsed);
      }
    }
  }, [props.showLastUsed]);

  return (
    <div>
      {props.providers.map((provider) => (
        <StyledButton
          key={provider}
          fullWidth
          disabled={pending === provider}
          onClick={() => onSigninWithProvider(provider)}
        >
          <IconWrapper>
            <img
              src={`https://uploads.divjoy.com/icon-${provider}.svg`}
              alt={providerDisplayNames[provider]}
            />
          </IconWrapper>

          {pending !== provider && (
            <span>
              {props.buttonAction} with {providerDisplayNames[provider]}
            </span>
          )}

          {pending === provider && <CircularProgress size={24} />}

          {provider === lastUsed && (
            <LastUsedIndicator>Last used</LastUsedIndicator>
          )}
        </StyledButton>
      ))}
    </div>
  );
}

export default AuthSocial;
